import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query'
import { logout } from '@wellesley/auth/hooks/useLogout'

type BQuery = BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>

// Endpoints where a 401 means the *external service* rejected the token,
// not that the user's app session expired.
const PROXY_ENDPOINT_PREFIXES = ['/api/v1/admin/fasp-remote/']

const getRequestUrl = (args: string | FetchArgs): string =>
  typeof args === 'string' ? args : args.url

export const baseQueryWithLogout =
  (baseQuery: BQuery): BQuery =>
  async (args, baseQueryApi, extraOptions) => {
    const result = await baseQuery(args, baseQueryApi, extraOptions)

    if (result.error && [401].includes(result.error.status as number)) {
      const url = getRequestUrl(args)
      const isProxiedEndpoint = PROXY_ENDPOINT_PREFIXES.some((prefix) =>
        url.includes(prefix),
      )
      if (!isProxiedEndpoint) {
        logout(baseQueryApi.dispatch)
      }
    }

    return result
  }
